if (!customElements.get('customer-testimonials')) {
  class CustomerTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.section = this.closest('.customer-testimonials-section');
      this.filterButtons = this.querySelectorAll('.product-filter-button');
      this.filterDropdownButton = this.querySelector('.product-filter-select-button');
      this.filterDropdownMenu = this.querySelector('.product-filter-select-menu');
      this.filterDropdownOptions = this.querySelectorAll('.product-filter-select-option');
      this.testimonialWrappers = this.querySelectorAll('.testimonial-card-wrapper');
      this.ratingContainer = this.querySelector('[data-rating-container]');
      const allFilterButton = Array.from(this.filterButtons).find(btn => btn.dataset.filter === 'all');
      this.defaultFilter = allFilterButton ? 'all' : (this.filterButtons.length > 0 ? this.filterButtons[0].dataset.filter : (this.filterDropdownOptions.length > 0 ? this.filterDropdownOptions[0].dataset.value : null));
      this.sliderInstance = null;
      this.gridContainer = this.querySelector('[data-testimonials-container]');
      
      const activeButton = this.querySelector('.product-filter-button.active');
      const selectedOption = this.querySelector('.product-filter-select-option.selected');
      this.currentFilter = activeButton ? activeButton.dataset.filter : (selectedOption ? selectedOption.dataset.value : this.defaultFilter);
      
      this.initSlider();

      if (this.defaultFilter) {
        this.testimonialWrappers.forEach((wrapper) => {
          const productHandle = wrapper.dataset.productHandle || 'none';
          
          if (this.currentFilter === 'all' || productHandle === this.currentFilter) {
            wrapper.style.display = '';
            wrapper.classList.remove('swiper-slide-hidden');
          } else {
            wrapper.style.display = 'none';
            wrapper.classList.add('swiper-slide-hidden');
          }
        });

        if (this.ratingContainer) {
          if (this.currentFilter === 'all') {
            this.calculateAggregateRating();
          } else {
            this.extractInitialRating();
          }
        }
      }

      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const filterValue = button.dataset.filter;
          this.currentFilter = filterValue;
          this.applyFilter(filterValue);
        });
      });

      if (this.filterDropdownButton && this.filterDropdownMenu) {
        this.initCustomDropdown();
      }
      
      window.addEventListener('resize', () => {
        this.initSlider();
        if (this.currentFilter) {
          this.applyFilter(this.currentFilter, true);
        }
      });
    }

    applyFilter(filterValue, skipRatingUpdate = false) {
      this.filterButtons.forEach((btn) => {
        if (btn.dataset.filter === filterValue) {
          btn.classList.add('active');
          btn.setAttribute('aria-selected', 'true');
        } else {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        }
      });

      if (this.filterDropdownOptions) {
        this.filterDropdownOptions.forEach((option) => {
          if (option.dataset.value === filterValue) {
            option.classList.add('selected');
            option.setAttribute('aria-selected', 'true');
            if (this.filterDropdownButton) {
              const buttonText = this.filterDropdownButton.querySelector('.product-filter-select-button-text');
              if (buttonText) {
                buttonText.textContent = option.textContent.trim();
              }
            }
          } else {
            option.classList.remove('selected');
            option.setAttribute('aria-selected', 'false');
          }
        });
      }

      this.testimonialWrappers = this.querySelectorAll('.testimonial-card-wrapper');
      
      this.testimonialWrappers.forEach((wrapper) => {
        const productHandle = wrapper.dataset.productHandle || 'none';
        
        if (filterValue === 'all' || productHandle === filterValue) {
          wrapper.style.display = '';
          wrapper.classList.remove('swiper-slide-hidden');
        } else {
          wrapper.style.display = 'none';
          wrapper.classList.add('swiper-slide-hidden');
        }
      });

      if (!skipRatingUpdate) {
        this.updateRating(filterValue);
      }
      
      if (this.sliderInstance) {
        setTimeout(() => {
          if (this.sliderInstance) {
            this.sliderInstance.update();
            this.sliderInstance.slideTo(0);
          }
        }, 100);
      }
    }
    
    hasOverflow() {
      if (!this.gridContainer) return false;
      
      const cards = Array.from(this.gridContainer.querySelectorAll('.testimonial-card-wrapper')).filter(card => {
        return card.style.display !== 'none' && !card.classList.contains('swiper-slide-hidden');
      });
      
      if (cards.length === 0) return false;
      
      const gridGap = parseFloat(getComputedStyle(this.gridContainer).getPropertyValue('--grid-gap')) || 18;
      let totalWidth = 0;
      
      cards.forEach((card, index) => {
        const cardWidth = parseFloat(getComputedStyle(card).getPropertyValue('--card-desktop-width')) || card.offsetWidth || 340;
        totalWidth += cardWidth;
        if (index < cards.length - 1) {
          totalWidth += gridGap;
        }
      });
      
      const containerWidth = this.gridContainer.offsetWidth || this.gridContainer.clientWidth;
      return totalWidth > containerWidth;
    }

    initSlider() {
      if (!this.section || !this.gridContainer) return;
      
      const enableSliderMobile = this.section.dataset.sliderMobile === 'true';
      const slidesPerViewMobile = parseFloat(this.section.dataset.slidesPerViewMobile || 1.2);
      const isMobile = window.innerWidth < 768;

      if (!isMobile) {
        if (this.sliderInstance) {
          this.sliderInstance.destroy(true, true);
          this.sliderInstance = null;
        }

        this.gridContainer.classList.remove('swiper-backface-hidden');
        this.gridContainer.classList.add('swiper');
        let wrapper = this.gridContainer.querySelector('.swiper-wrapper');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'swiper-wrapper';
          while (this.gridContainer.firstChild) {
            wrapper.appendChild(this.gridContainer.firstChild);
          }
          this.gridContainer.appendChild(wrapper);
        }

        this.testimonialWrappers = this.querySelectorAll('.testimonial-card-wrapper');
        this.testimonialWrappers.forEach((w) => {
          w.classList.add('swiper-slide');
        });

        const gridGap = parseFloat(getComputedStyle(this.gridContainer).getPropertyValue('--grid-gap')) || 18;

        this.sliderInstance = new Swiper(this.gridContainer, {
          slidesPerView: 'auto',
          spaceBetween: gridGap,
          loop: false,
          speed: 600,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          threshold: 2
        });
        return;
      }
      
      if (isMobile && enableSliderMobile) {
        if (this.sliderInstance) {
          this.sliderInstance.destroy(true, true);
          this.sliderInstance = null;
        }
        
        this.gridContainer.classList.add('swiper');
        let wrapper = this.gridContainer.querySelector('.swiper-wrapper');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'swiper-wrapper';
          while (this.gridContainer.firstChild) {
            wrapper.appendChild(this.gridContainer.firstChild);
          }
          this.gridContainer.appendChild(wrapper);
        }
        
        this.testimonialWrappers = this.querySelectorAll('.testimonial-card-wrapper');
        this.testimonialWrappers.forEach((wrapper) => {
          wrapper.classList.add('swiper-slide');
        });
        
        this.sliderInstance = new Swiper(this.gridContainer, {
          slidesPerView: slidesPerViewMobile,
          centeredSlides: true,
          spaceBetween: 16,
          loop: false,
          speed: 800,
          watchOverflow: true,
          observer: true,
          observeParents: true
        });
      }
    }

    updateRating(filterValue) {
      if (!this.ratingContainer) return;

      if (filterValue === 'all') {
        this.calculateAggregateRating();
        return;
      }

      const filterButton = this.querySelector('[data-filter="' + filterValue + '"]');
      
      if (filterButton && filterButton.dataset.badgeHtml) {
        const badgeHtml = decodeURIComponent(filterButton.dataset.badgeHtml.replace(/\+/g, ' '));
        this.processBadgeHtml(badgeHtml, filterButton.dataset.productId);
        return;
      }

      if (this.filterDropdownOptions) {
        const dropdownOption = Array.from(this.filterDropdownOptions).find(opt => opt.dataset.value === filterValue);
        if (dropdownOption && dropdownOption.dataset.badgeHtml) {
          const badgeHtml = decodeURIComponent(dropdownOption.dataset.badgeHtml.replace(/\+/g, ' '));
          this.processBadgeHtml(badgeHtml, dropdownOption.dataset.productId);
        }
      }
    }

    processBadgeHtml(badgeHtml, productId) {
      
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = badgeHtml;
      
      const badgeWrapper = tempDiv.querySelector('.jdgm-widget.jdgm-preview-badge');
      if (!badgeWrapper) return;

      const hiddenBadge = this.ratingContainer.querySelector('.jdgm-badge-wrapper');
      if (hiddenBadge) {
        hiddenBadge.innerHTML = badgeWrapper.innerHTML;
        hiddenBadge.setAttribute('data-id', productId);
        hiddenBadge.setAttribute('data-product-id', productId);
        
        if (window.jdgm) {
          if (typeof window.jdgm.loadWidget === 'function') {
            window.jdgm.loadWidget(hiddenBadge);
          } else if (window.jdgm.widgetLoader) {
            window.jdgm.widgetLoader.loadBadge(hiddenBadge);
          }
        }
      }

      setTimeout(() => {
        const badge = this.ratingContainer.querySelector('.jdgm-badge-wrapper .jdgm-prev-badge');
        if (badge) {
          const averageRating = badge.getAttribute('data-average-rating');
          
          const starsDisplay = this.ratingContainer.querySelector('.testimonials-rating-stars');
          const textDisplay = this.ratingContainer.querySelector('.testimonials-rating-text');
          
          if (starsDisplay && averageRating) {
            const rating = parseFloat(averageRating);
            const starsHTML = '<span class="jdgm-star jdgm--on"></span>'.repeat(5);
            
            starsDisplay.innerHTML = '<span class="jdgm-prev-badge__stars" data-score="' + rating + '">' + starsHTML + '</span>';
          }
          
          if (textDisplay && averageRating) {
            const ratingRounded = Math.round(parseFloat(averageRating) * 10) / 10;
            textDisplay.textContent = ratingRounded + ' Stars';
          }
        }
      }, 300);
    }

    calculateAggregateRating() {
      const starsDisplay = this.ratingContainer.querySelector('.testimonials-rating-stars');
      const textDisplay = this.ratingContainer.querySelector('.testimonials-rating-text');
      
      if (!starsDisplay && !textDisplay) return;

      const productRatings = new Map();
      
      this.testimonialWrappers.forEach((wrapper) => {
        const rating = parseFloat(wrapper.dataset.productRating);
        const count = parseFloat(wrapper.dataset.productRatingCount) || 0;
        
        if (!isNaN(rating) && rating > 0) {
          const productHandle = wrapper.dataset.productHandle || 'none';
          
          if (productRatings.has(productHandle)) {
            const existing = productRatings.get(productHandle);
            if (count > existing.count) {
              productRatings.set(productHandle, { rating, count });
            }
          } else {
            productRatings.set(productHandle, { rating, count });
          }
        }
      });

      if (productRatings.size === 0) {
        if (starsDisplay) starsDisplay.innerHTML = '';
        if (textDisplay) textDisplay.textContent = '';
        return;
      }

      let totalWeightedRating = 0;
      let totalCount = 0;
      
      productRatings.forEach(({ rating, count }) => {
        totalWeightedRating += rating * count;
        totalCount += count;
      });

      const aggregateRating = totalCount > 0 ? totalWeightedRating / totalCount : 0;
      const ratingRounded = Math.round(aggregateRating * 10) / 10;

      if (starsDisplay) {
        const starsHTML = '<span class="jdgm-star jdgm--on"></span>'.repeat(5);
        starsDisplay.innerHTML = '<span class="jdgm-prev-badge__stars" data-score="' + ratingRounded + '">' + starsHTML + '</span>';
      }
      
      if (textDisplay) {
        textDisplay.textContent = ratingRounded + ' Stars';
      }
    }

    extractInitialRating() {
      const hiddenBadge = this.ratingContainer.querySelector('.jdgm-badge-wrapper');
      if (!hiddenBadge) return;

      setTimeout(() => {
        const badge = hiddenBadge.querySelector('.jdgm-prev-badge');
        if (badge) {
          const averageRating = badge.getAttribute('data-average-rating');
          
          const starsDisplay = this.ratingContainer.querySelector('.testimonials-rating-stars');
          const textDisplay = this.ratingContainer.querySelector('.testimonials-rating-text');
          
          if (starsDisplay && averageRating) {
            const rating = parseFloat(averageRating);
            const starsHTML = '<span class="jdgm-star jdgm--on"></span>'.repeat(5);
            
            starsDisplay.innerHTML = '<span class="jdgm-prev-badge__stars" data-score="' + rating + '">' + starsHTML + '</span>';
          }
          
          if (textDisplay && averageRating) {
            const ratingRounded = Math.round(parseFloat(averageRating) * 10) / 10;
            textDisplay.textContent = ratingRounded + ' Stars';
          }
        }
      }, 500);
    }

    initCustomDropdown() {
      this.filterDropdownButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleDropdown();
      });

      this.filterDropdownOptions.forEach((option) => {
        option.addEventListener('click', () => {
          const filterValue = option.dataset.value;
          this.currentFilter = filterValue;
          this.applyFilter(filterValue);
          this.closeDropdown();
        });
      });

      document.addEventListener('click', (e) => {
        if (!this.filterDropdownButton.contains(e.target) && !this.filterDropdownMenu.contains(e.target)) {
          this.closeDropdown();
        }
      });

      this.filterDropdownButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleDropdown();
        } else if (e.key === 'Escape') {
          this.closeDropdown();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.openDropdown();
          this.focusOption(0);
        }
      });

      this.filterDropdownMenu.addEventListener('keydown', (e) => {
        const options = Array.from(this.filterDropdownOptions);
        const currentIndex = options.findIndex(opt => opt === document.activeElement);

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
          this.focusOption(nextIndex);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prevIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
          this.focusOption(prevIndex);
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (document.activeElement.classList.contains('product-filter-select-option')) {
            document.activeElement.click();
          }
        } else if (e.key === 'Escape') {
          this.closeDropdown();
          this.filterDropdownButton.focus();
        }
      });
    }

    toggleDropdown() {
      const isOpen = this.filterDropdownMenu.classList.contains('open');
      if (isOpen) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      this.filterDropdownMenu.classList.add('open');
      this.filterDropdownButton.setAttribute('aria-expanded', 'true');
    }

    closeDropdown() {
      this.filterDropdownMenu.classList.remove('open');
      this.filterDropdownButton.setAttribute('aria-expanded', 'false');
    }

    focusOption(index) {
      const options = Array.from(this.filterDropdownOptions);
      if (options[index]) {
        options[index].focus();
      }
    }
  }

  customElements.define('customer-testimonials', CustomerTestimonials);
}

